import conditionLabel from './conditionLabel'
import paymentMethodLabel from './paymentMethodLabel'

const paymentMethoPriceTables = {
  conditionLabel,
  paymentMethodLabel,
}

export default paymentMethoPriceTables
